export interface IframeProps
  extends React.IframeHTMLAttributes<HTMLIFrameElement> {}

function isValidHttpUrl(urlString: string | undefined): boolean {
  if (!urlString) return false;

  try {
    const url = new URL(urlString);
    // Only allow http and https protocols to prevent XSS attacks
    // Block dangerous protocols like javascript:, data:, vbscript:, etc.
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (err) {
    // Invalid URL format
    return false;
  }
}

export function Iframe({ ...props }: IframeProps) {
  // Validate src to prevent XSS attacks
  if (!isValidHttpUrl(props.src)) {
    console.error("Invalid or unsafe iframe src detected:", props.src);
    return null; // Don't render iframe with unsafe src
  }

  return (
    <iframe
      {...props}
      width="100%"
      height="1080"
      title={props.src}
      allowFullScreen
    ></iframe>
  );
}
